import { mapTrainingProgramConfigFromApiToVm } from 'modules/settings/pods/settings-training-settings/domain';
import { API, VM } from '..';

export const mapAppSettingsFromApiToModel = (appSettings: API.AppSettingsConfig) => ({
    tenantConfig: mapTenantConfigFromApiToModel(appSettings.tenantConfig),
    trainingProgramsConfig: mapTrainingProgramConfigFromApiToVm(appSettings.trainingProgramsConfig),
});

export const mapTenantConfigFromApiToModel = (tenantConfig: API.TenantConfig): VM.TenantConfig => ({
    zoneId: tenantConfig.zoneId,
});
